// @flow

import React from 'react'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import { Container } from '../../../components/basic/Grid'
import Carousel from '../../../components/basic/Carousel'
import messages from '../CaseStudy.lang'
import baseStyles from './CaseFeedback.scss'
import { FormattedMessageSanitized } from '../../FormattedMessageSanitized'

type Props = {
  ...StyleProps,
  list: Object
}

const CaseFeedback = ({ styles, list }: Props) => {
  const { formatMessage } = useIntl()
  const slidesCount = list.length

  return (
    <div className={styles.root}>
      <Container className={styles.container} fluid>
        <h3 className={styles.title}>{formatMessage(messages.feedbackTitle)}</h3>
        <Carousel
          styles={styles.slider}
          settings={{
            swipe: true,
            lazyLoad: false,
            infinite: false,
            dots: true,
            adaptiveHeight: true,
            arrows: false,
            responsive: [
              {
                breakpoint: 500,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: slidesCount < 2 ? slidesCount : 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 1199,
                settings: {
                  slidesToShow: slidesCount < 3 ? slidesCount : 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 1439,
                settings: {
                  slidesToShow: slidesCount < 3 ? slidesCount : 3,
                  slidesToScroll: 1,
                  swipe: true
                }
              },
              {
                breakpoint: 9999,
                settings: {
                  slidesToShow: slidesCount < 3 ? slidesCount : 3,
                  slidesToScroll: 1,
                  swipe: true
                }
              }
            ]
          }}
        >
          {list.map((item, i) => (
            <div className={styles.item} key={'feedback' + i}>
              <p className={styles.text}>
                <FormattedMessageSanitized {...item.text} />
              </p>
              <div className={styles.from}>
                <FormattedMessageSanitized {...item.from} />
              </div>
              <div className={styles.imgContainer}>{item.img}</div>
            </div>
          ))}
        </Carousel>
      </Container>
    </div>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(CaseFeedback)
